import { cn } from "../../lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-secondary-background/20 border-2 border-border", className)}
      {...props}
    />
  )
}

export { Skeleton }